// TurnoStackedBarChart.jsx
import React from 'react';
import { StackedBarChart } from '@carbon/charts-react';
import '@carbon/charts/styles.css';

const TurnoStackedBarChart = ({
  data = [],
  title = 'Desglose de jornada por turno',
  height = '400px',
}) => {
  // Carbon Charts requiere formato: { group, key, value }
  const chartData = data.flatMap((t) =>
    t.segmentos.map((seg) => ({
      group: seg.label,   // "TIEMPO FUERA DE SERVICIO", etc.
      key: t.label,       // "2025-11-20 Día" / "2025-11-20 Noche"
      value: seg.value_h, // horas
    }))
  );

  const options = {
    title,
    height,
    theme: 'g100', // ⬅⬅⬅ modo dark → textos claros/blancos

    axes: {
      left: {
        mapsTo: 'value',
        title: 'Horas',
        scaleType: 'linear',
      },
      bottom: {
        mapsTo: 'key',
        title: 'Turno (día/noche)',
        scaleType: 'labels',
      },
    },

    legend: {
      enabled: true,
      truncation: {
        type: 'none', // ⬅⬅⬅ evita que se corte el texto
      },
    },

    bar: {
      stacked: true,
    },

    // 🎨 Colores personalizados (se mantienen igual que los tuyos)
    color: {
      scale: {
        'TIEMPO FUERA DE SERVICIO': '#8A3FFC',
        'TIEMPO EN ESPERA (incl. colación e inicio/fin)': '#0F62FE',
        'DEMORAS COMBUSTIBLE': '#FDDC69',
        'TIEMPO NO PRODUCTIVO': '#EB6200',
        'TIEMPO PRODUCTIVO': '#007D79',
      },
    },
  };

  return <StackedBarChart data={chartData} options={options} />;
};

export default TurnoStackedBarChart;
